import { render, staticRenderFns } from "./CategoryTile.vue?vue&type=template&id=26459ffc&scoped=true&"
import script from "./CategoryTile.vue?vue&type=script&lang=js&"
export * from "./CategoryTile.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTile.vue?vue&type=style&index=0&id=26459ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26459ffc",
  null
  
)

export default component.exports